import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.BillsInformation.AddBeneficiaryPopupContent.SuccessPopup',
    {
        title: 'The beneficiary has been successfully created.',
        confirmButton: 'DONE',
    }
);
